import { render, staticRenderFns } from "./PayeeDetailCard.vue?vue&type=template&id=697382d2&scoped=true"
import script from "./PayeeDetailCard.vue?vue&type=script&lang=ts"
export * from "./PayeeDetailCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697382d2",
  null
  
)

export default component.exports